import forEach from '@Utils/forEach'

export default class PreviewLink {
  constructor () {
    forEach(document.querySelectorAll('[data-role="preview-link"]'), (i, el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        App.dispatcher.fire('quick-preview.open', el.dataset.pid)
      })
    })
  }
}
